/*
import { ContactService } from '../service/contact';
const cs = new ContactService();
const _init=async()=>{
    console.log(await ob.getContact({user_id:0}));
};
*/

import { API_ROUTE_CONTROLLER, API_VERBS } from "./route";
import { BaseService } from "./base";
import Cookies from 'universal-cookie';
import { API_HOST } from "../config";

const cookies = new Cookies();

export class NumberService extends BaseService {
    getDidNumPurchase = async () => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getCountryList));
    };
    getNumberType = async () => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getGroupType));
    };
    geTataNumPurchase = async () => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getTataCountryList));
    };
    ǧetPurchaseOrder = async () => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getOrderPurchase));
    };
    getCityList = async (values) => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getCityList + "/" + values));
    };
    getTataCityList = async (values) => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getTataCityList + "/" + values));
    };
    getSkuIdApi = async (countryId, cityId, features) => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getskuId + "?countryId=" + countryId + "&cityId=" + cityId + "&features=" + features));
    };
    getDocument = async (value) => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getDocumentReq + "/" + value));
    };
    getAvaldidList = async (value, countrycode, features, numbervalue) => {
        let returnValue = '';
        if(!value) returnValue = `?countryId=${countrycode}&features=${features}&groupTypeId=${numbervalue}`;
        else returnValue = `?cityId=${value}&countryId=${countrycode}&features=${features}&groupTypeId=${numbervalue}`;
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getDidList + returnValue));
    };
    getTataAvailDidList = async (value, productID, cityCode) => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getTataAvailDidList + value + "&productId=" + productID + "&cityCode=" + cityCode));
    };
    getLocations = async () => {
        return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.Urgetmyaccuserlocation));
    };
    getAreaCodeall = async (_body) => {
        return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmaphonenumbergetcity, _body));
    };
    getFreePhoneNumbersService = async (_body) => {
        return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Getlandlinenumberlist, _body));
    };
    getMobilePhoneNumbersService = async (_body) => {
        return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccountgetavaialblemsisdn, _body));
    };
    getGeoNumbersService = async (_body) => {
        return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Getlandlinenumberlist, _body));
    };
    getLocalPhoneNumbersService = async (_body) => {
        return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmaphoneaddnumbergetnumberdtl, _body));
    };
    getBillingDetailService = async (_body) => {
        return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.UrgetBillServicePlan, _body));
    };
    ecompayStemService = async (_body, url) => {
        return await this.getResponse(await this.post(url, _body));
    };
    getThreedsFormService = async (_body, url) => {
        return await this.getResponse(await this.post(url, _body));
    };
    ecomPaymentCheck3dsService = async (url, _body) => {
        return await this.getResponse(await this.post(url, _body));
    };
    paymentCommonService = async (url, _body) => {
        return await this.getResponse(await this.post(url, _body));
    };
    purchaseOrder = async (_url, _body) => {
        return await this.getResponse(await this.post(_url, _body));
    };


}
